<app-ion-common-header [id]="headerId" (backHeader)="backPage()" (focusHeader)="shownContent()" [title]="titleWebPage" start="{{startStage}}" end="{{endStage}}"></app-ion-common-header>

<ion-content [attr.aria-hidden]="ariaHidden" [style.visibility]="ariaHidden ? 'hidden' : 'visible'">
  
<app-ion-common-label class="document-type-label1" labelStyle="display-rg" 
  [labelDescription]="title" [labelAria]="labelAria">
</app-ion-common-label>

<form [formGroup]="phoneForm" (ngSubmit)="submitForm($event)">
  <div class="conent-center conent-center--mrt-lg">
    <app-ion-common-input
      [fieldValue]="number"
      [placeholder]="placeholder"
      [maxLength]="maxLength"
      [error]="error" 
      (textChange)="number=$event; errorMsg();"
      [textError]="textError"
      [id]="idComponentNumber"
      [type]="type"
      [idLabel]="idLabel"
      [replaceStrTo]="replaceStrTo"
      [label]="label"
      name="docPhone"
      [disabled]="!this.edit"
      formControlName="docPhone"
      ngDefaultControl
      >
    </app-ion-common-input>
  </div>
</form>
<app-ion-common-button class="hidden" [ngClass]="{'hidden': !buttonEnable || number.length === 0}" [attr.aria-hidden]="!buttonEnable"
label="Continuar" (clickButton)="clickNext();"></app-ion-common-button>
</ion-content>